var _style, _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHunmotors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{fill:url(#SVGID_5_);}\r\n\t.st5{fill:url(#SVGID_6_);}\r\n\t.st6{fill:url(#SVGID_7_);}\r\n\t.st7{fill:url(#SVGID_8_);}\r\n\t.st8{fill:url(#SVGID_9_);}\r\n\t.st9{fill:url(#SVGID_10_);}\r\n\t.st10{fill:url(#SVGID_11_);}\r\n\t.st11{fill:url(#SVGID_12_);}\r\n\t.st12{fill:url(#SVGID_13_);}\r\n\t.st13{fill:url(#SVGID_14_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.7721,
    y1: 208.1219,
    x2: 265.9256,
    y2: 208.1219
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F5668"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#373D4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181D28"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.95,155.85c0,3.78,0.18,9.43,0.54,16.96c0.36,7.53,0.54,13.16,0.54,16.88c0,1.81-0.62,2.87-1.86,3.18 c-1.76,0.42-8.18,0.62-19.25,0.62c-11.9,0-18.52-0.21-19.87-0.62c-0.98-0.31-1.47-1.37-1.47-3.18c0-3.88,0.28-9.69,0.85-17.42 c0.57-7.73,0.85-13.54,0.85-17.42c0-0.93-0.44-1.4-1.32-1.4c-1.66,0-4.15,0.08-7.49,0.23c-3.34,0.15-5.83,0.23-7.49,0.23 c-1.6,0-4.02-0.08-7.26-0.23c-3.23-0.15-5.65-0.23-7.26-0.23c-1.09,0-1.63,0.57-1.63,1.71c0,6,0.26,15.02,0.78,27.05 c0.52,12.03,0.78,21.05,0.78,27.05c0,5.64-0.27,14.1-0.81,25.38c-0.54,11.28-0.82,19.71-0.82,25.3c0,1.35,0.75,2.15,2.25,2.41 c1.91,0.31,6.36,0.47,13.35,0.47c8.07,0,12.93-0.15,14.59-0.47c1.4-0.26,2.1-1.16,2.1-2.72c0-4.04-0.13-10.08-0.39-18.12 c-0.26-8.04-0.39-14.09-0.39-18.12c0-2.07,0.57-3.23,1.71-3.49c1.81-0.41,8.12-0.62,18.94-0.62c10.76,0,17.02,0.21,18.78,0.62 c1.14,0.31,1.71,1.48,1.71,3.49c0,4.09-0.19,10.23-0.58,18.43c-0.39,8.2-0.58,14.35-0.58,18.43c0,1.09,0.71,1.79,2.13,2.09 c1.42,0.31,6.2,0.47,14.32,0.47c5.74,0,10.19-0.15,13.35-0.47h0.41c0.23,0,0.42-0.06,0.61-0.11c0.61-0.08,1.01-0.17,1.15-0.28 c0.47-0.26,0.7-0.93,0.7-2.02c0-4.92-0.21-12.04-0.63-21.37c-0.01-0.59-0.03-1.15-0.04-1.76c-0.26-10.14-0.39-17.75-0.39-22.82 c0-1.03,0.18-1.79,0.54-2.25c0.12,0.1,0.2,0.19,0.28,0.29l-31.09-58.09C234.18,154.32,233.95,154.94,233.95,155.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.5962,
    y1: 208.1219,
    x2: 351.011,
    y2: 208.1219
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E37727"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.31,234.47c-0.47-11.28-0.7-19.74-0.7-25.38c0-6.1,0.22-15.22,0.66-27.36 c0.44-12.13,0.66-21.25,0.66-27.36c0-1.24-0.78-1.86-2.33-1.86c-1.29,0-3.27,0.13-5.94,0.39c-2.67,0.26-4.64,0.39-5.94,0.39 c-1.55,0-3.84-0.08-6.87-0.23c-3.03-0.15-5.29-0.23-6.79-0.23c-1.04,0-1.99,1.01-2.87,3.03c-10.24,21.89-17.98,38.26-23.21,49.13 c-1.86,3.88-3.08,5.82-3.65,5.82c-1.09,0-2.43-1.68-4.04-5.04l-22.66-49.75c-1.04-2.17-1.84-3.26-2.41-3.26 c-2.85,0-7.11,0.09-12.81,0.27c-5.69,0.18-9.96,0.27-12.81,0.27c-0.31,0-0.59,0.01-0.85,0.03c-0.71-0.02-1.37-0.03-1.89-0.03 c-0.56,0-0.98,0.18-1.29,0.48l31.09,58.09c0.19,0.2,0.34,0.39,0.41,0.57c0.24,0.5,0.5,1.07,0.76,1.63l0.01,0.02l-0.01-0.02 c2.41,5.18,5.8,12.93,10.18,23.28c4.55,10.87,8.23,19.14,11.02,24.83c0.52,1.04,2.12,1.55,4.81,1.55c1.81,0,2.84-0.03,3.1-0.08 c0.78-0.21,1.42-0.91,1.94-2.1c3.72-9.16,7.45-18.34,11.18-27.55c6.36-15.68,9.83-23.67,10.4-23.98c0.47,0.1,0.7,0.9,0.7,2.41 c0,5.23-0.19,13.07-0.58,23.52c-0.39,10.45-0.58,18.29-0.58,23.52c0,1.81,0.75,2.72,2.25,2.72h27.48c1.5,0,2.25-0.8,2.25-2.41 C351.01,254.18,350.78,245.75,350.31,234.47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.0749,
    y1: 111.2926,
    x2: 243.9591,
    y2: 439.4113,
    gradientTransform: "matrix(0.7071 0.7071 -0.7071 0.7071 263.8923 -69.0945)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F5668"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#373D4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181D28"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M135.47,208.12c0-55.64,45.1-100.74,100.74-100.74l0-70.72c-6.22,0-12.35,0.35-18.4,1l-6.71,30.72 c-7.92,1.42-15.63,3.46-23.04,6.13l-21.14-23.21c-11.32,5.01-21.99,11.19-31.87,18.42l9.54,29.95 c-6.07,5.13-11.7,10.77-16.84,16.84l-29.95-9.54c-7.23,9.87-13.41,20.55-18.42,31.87l23.21,21.14 c-2.67,7.41-4.72,15.12-6.13,23.04l-30.72,6.71c-0.65,6.05-1,12.18-1,18.4c0,6.22,0.35,12.35,1,18.4l30.72,6.71 c1.42,7.92,3.46,15.63,6.13,23.04l-23.21,21.14c5.01,11.32,11.19,21.99,18.42,31.87l29.95-9.54c5.13,6.07,10.77,11.7,16.84,16.84 l-9.54,29.95c9.87,7.23,20.55,13.41,31.87,18.42l21.14-23.21c7.41,2.67,15.12,4.72,23.04,6.13l6.71,30.72 c6.05,0.65,12.18,1,18.4,1l0-70.72C180.57,308.86,135.47,263.76,135.47,208.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 178.8625,
    y1: 9.7496,
    x2: 350.2554,
    y2: 351.6184,
    gradientTransform: "matrix(0.7071 0.7071 -0.7071 0.7071 263.8923 -69.0945)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E37727"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M301.37,78.28c0,0-1.78,0.81-4.45,2.01c47.76,22.73,80.78,71.41,80.78,127.82 c0,71.29-52.73,130.24-121.31,140.04v30.2c85.18-10,151.28-82.38,151.28-170.24c0-69.25-41.07-128.86-100.17-155.93l1.71,6.03 L301.37,78.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.9357,
    y1: 48.8173,
    x2: 272.328,
    y2: 390.685,
    gradientTransform: "matrix(0.7071 0.7071 -0.7071 0.7071 263.8923 -69.0945)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E37727"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M288.27,75.08l-26.17-8.32c1.39,10.77,8.76,20.31,19.79,23.82c15.18,4.83,31.4-3.56,36.22-18.74 c4.83-15.18-3.56-31.4-18.74-36.22c-11.03-3.51-22.56,0.03-29.91,8.01l26.17,8.32l4.08,14.03L288.27,75.08z"
  }))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M126.3,450.43c0,0.48-0.1,0.77-0.31,0.88c-0.09,0.07-0.41,0.13-0.95,0.17c-1.38,0.14-3.33,0.2-5.85,0.2 c-3.56,0-5.65-0.07-6.27-0.2c-0.62-0.14-0.94-0.44-0.94-0.92c0-1.79,0.08-4.48,0.25-8.08c0.17-3.59,0.25-6.29,0.25-8.08 c0-0.88-0.25-1.39-0.75-1.53c-0.77-0.18-3.51-0.27-8.23-0.27c-4.74,0-7.5,0.09-8.3,0.27c-0.5,0.11-0.75,0.62-0.75,1.53 c0,1.77,0.06,4.42,0.17,7.94c0.11,3.53,0.17,6.17,0.17,7.94c0,0.68-0.31,1.08-0.92,1.19c-0.73,0.14-2.86,0.2-6.39,0.2 c-3.06,0-5.01-0.07-5.85-0.2c-0.66-0.11-0.99-0.46-0.99-1.05c0-2.45,0.12-6.14,0.36-11.09c0.24-4.94,0.36-8.65,0.36-11.12 c0-2.63-0.11-6.58-0.34-11.85c-0.23-5.27-0.34-9.22-0.34-11.85c0-0.5,0.24-0.75,0.71-0.75c0.7,0,1.76,0.03,3.18,0.1 c1.42,0.07,2.48,0.1,3.18,0.1c0.73,0,1.82-0.03,3.28-0.1s2.56-0.1,3.28-0.1c0.39,0,0.58,0.2,0.58,0.61c0,1.7-0.13,4.25-0.37,7.63 c-0.25,3.39-0.37,5.93-0.37,7.63c0,0.79,0.21,1.26,0.65,1.39c0.59,0.18,3.49,0.27,8.71,0.27c4.85,0,7.66-0.09,8.43-0.27 c0.54-0.14,0.82-0.6,0.82-1.39c0-1.63-0.08-4.1-0.24-7.4c-0.16-3.3-0.24-5.78-0.24-7.43c0-0.7,0.28-1.05,0.85-1.05 c0.66,0,1.66,0.03,3.01,0.1c1.35,0.07,2.36,0.1,3.04,0.1c0.66,0,1.66-0.03,3.01-0.1c1.35-0.07,2.36-0.1,3.04-0.1 c0.66,0,0.99,0.27,0.99,0.82c0,2.61-0.11,6.54-0.32,11.8s-0.32,9.21-0.32,11.83c0,2.47,0.12,6.18,0.36,11.12 S126.3,447.99,126.3,450.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.31,420.58c0,1.68-0.08,4.2-0.24,7.55c-0.16,3.36-0.24,5.87-0.24,7.55c0,1.63,0.06,4.08,0.17,7.35 c0.11,3.26,0.17,5.7,0.17,7.31c0,0.61-0.28,1-0.85,1.16c-0.86,0.23-2.69,0.34-5.48,0.34c-2.47,0-4.19-0.07-5.17-0.2 c-0.43-0.07-0.7-0.34-0.82-0.82c-0.07-0.68-0.14-1.36-0.2-2.04c-0.11-1.04-0.27-1.56-0.48-1.56c0.32,0-0.83,0.77-3.43,2.31 c-2.61,1.54-4.98,2.31-7.11,2.31c-6.01,0-9.57-2.71-10.68-8.13c-0.5-2.52-0.75-6.17-0.75-10.95c0-5.17,0.42-9.25,1.26-12.24 c0.25-0.93,0.71-1.39,1.39-1.39c1.04,0,2.63,0.01,4.76,0.03c2.13,0.02,3.72,0.03,4.76,0.03c0.7,0,1.05,0.29,1.05,0.88 c0,0.16-0.02,0.4-0.07,0.71c-0.48,3.08-0.71,6.21-0.71,9.39c0,3.94,0.12,6.64,0.37,8.09c0.41,2.49,1.89,3.74,4.46,3.74 c1,0,2.08-0.44,3.25-1.33c1.17-0.88,1.77-1.8,1.82-2.75c0.05-0.84,0.07-6.53,0.07-17.07c0-0.75,0.06-1.19,0.17-1.33 c0.14-0.23,0.54-0.34,1.22-0.34c1.11,0,2.78,0.01,5.02,0.03c2.23,0.02,3.91,0.03,5.02,0.03c0.68,0,1.08,0.17,1.19,0.51 C167.29,419.94,167.31,420.21,167.31,420.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.72,450.5c0,0.61-0.32,0.96-0.95,1.05c-0.63,0.09-2.29,0.14-4.96,0.14c-2.86,0-4.63-0.07-5.31-0.2 s-1.02-0.6-1.02-1.39c0-1.07,0.03-2.67,0.1-4.83c0.07-2.15,0.1-3.77,0.1-4.86c0-0.84-0.02-2.09-0.07-3.76 c-0.05-1.67-0.07-2.92-0.07-3.76c0-3.11-1.35-4.66-4.05-4.66c-0.88,0-1.92,0.39-3.09,1.16c-1.27,0.86-1.9,1.71-1.9,2.55v18.36 c0,0.75-0.35,1.17-1.05,1.26c-0.79,0.09-2.41,0.14-4.86,0.14c-2.65,0-4.38-0.07-5.17-0.2c-0.7-0.11-1.05-0.49-1.05-1.12 c0-1.77,0.01-4.43,0.03-7.99c0.02-3.56,0.03-6.23,0.03-8.03c0-5.65-0.44-10.08-1.33-13.3c-0.05-0.2-0.07-0.37-0.07-0.51 c0-0.36,0.17-0.61,0.51-0.75c1.43-0.16,3.33-0.41,5.71-0.75c3.6-0.7,5.63-1.05,6.09-1.05c0.25,0,0.44,0.76,0.58,2.29 c0.14,1.53,0.33,2.3,0.58,2.3c-0.25,0,0.97-0.79,3.66-2.36c2.69-1.58,5.04-2.36,7.06-2.36c2.88,0,5.28,0.68,7.21,2.04 c2.15,1.56,3.23,3.74,3.23,6.53v10.85c0,1.47,0.01,3.68,0.03,6.61C206.71,446.83,206.72,449.03,206.72,450.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.76,450.43c0,0.7-0.33,1.05-0.99,1.05h-12.04c-0.66,0-0.99-0.4-0.99-1.19c0-2.29,0.09-5.72,0.26-10.3 c0.17-4.58,0.25-8.01,0.25-10.3c0-0.66-0.1-1.01-0.31-1.05c-0.25,0.14-1.77,3.64-4.56,10.51c-1.63,4.04-3.26,8.06-4.9,12.07 c-0.23,0.52-0.51,0.83-0.85,0.92c-0.12,0.02-0.57,0.03-1.36,0.03c-1.18,0-1.88-0.23-2.11-0.68c-1.22-2.49-2.83-6.12-4.83-10.88 c-2.13-5.03-3.73-8.67-4.79-10.92c-0.05-0.11-0.15-0.24-0.31-0.37c-0.16,0.2-0.24,0.53-0.24,0.99c0,2.22,0.06,5.55,0.17,10 s0.17,7.78,0.17,10c0,0.79-0.32,1.19-0.95,1.19h-11.36c-0.45,0-0.73-0.07-0.83-0.22s-0.15-0.4-0.15-0.77 c0-2.47,0.12-6.18,0.36-11.14c0.24-4.95,0.36-8.67,0.36-11.14c0-2.63-0.11-7.56-0.34-14.79c-0.02-1.88-0.13-4.68-0.31-8.4 l-0.03-0.58c-0.02-0.45,0.45-0.68,1.43-0.68c1.25,0,3.12-0.04,5.61-0.12c2.49-0.08,4.36-0.12,5.61-0.12 c0.25,0,0.6,0.48,1.05,1.43l9.93,21.8c0.7,1.47,1.29,2.21,1.77,2.21c0.25,0,0.78-0.85,1.6-2.55c2.29-4.76,5.68-11.94,10.17-21.53 c0.38-0.88,0.8-1.33,1.26-1.33c0.66,0,1.65,0.03,2.98,0.1s2.33,0.1,3.01,0.1c0.57,0,1.43-0.06,2.6-0.17 c1.17-0.11,2.04-0.17,2.6-0.17c0.68,0,1.02,0.27,1.02,0.82c0,2.68-0.1,6.67-0.29,11.99c-0.19,5.32-0.29,9.31-0.29,11.99 c0,2.47,0.1,6.18,0.31,11.12S280.76,447.99,280.76,450.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.56,434.76c0,5.17-1.58,9.36-4.74,12.58c-3.16,3.22-7.32,4.83-12.46,4.83c-4.99,0-9.09-1.59-12.31-4.76 c-3.22-3.17-4.83-7.25-4.83-12.24c0-5.26,1.54-9.53,4.63-12.8s7.25-4.91,12.52-4.91c5.12,0,9.27,1.6,12.45,4.81 C317.97,425.47,319.56,429.63,319.56,434.76z M308.41,434.76c0-1.79-0.56-3.37-1.67-4.74c-1.11-1.37-2.55-2.06-4.32-2.06 c-1.79,0-3.26,0.7-4.42,2.11c-1.09,1.32-1.63,2.88-1.63,4.69c0,1.84,0.54,3.41,1.63,4.73c1.16,1.41,2.63,2.11,4.42,2.11 c1.77,0,3.23-0.7,4.39-2.11C307.87,438.17,308.41,436.59,308.41,434.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.43,441.53c0,0.68-0.08,1.71-0.25,3.09s-0.25,2.4-0.25,3.04c0,0.65-0.07,1.06-0.2,1.24 c-0.14,0.18-0.51,0.44-1.12,0.78c-2.92,1.61-6.17,2.42-9.73,2.42c-6.55,0-9.83-2.5-9.83-7.52c0-1.5,0.06-3.75,0.17-6.75 c0.11-3,0.17-5.25,0.17-6.75c0-1-0.58-1.5-1.73-1.5c-0.09,0-0.24,0-0.44,0c-0.2,0.02-0.35,0.03-0.44,0.03 c-0.86,0-1.29-0.31-1.29-0.92c0-0.36,0.03-0.92,0.09-1.67c0.06-0.75,0.08-1.3,0.08-1.67c0-0.48-0.03-1.2-0.08-2.18 c-0.06-0.97-0.09-1.7-0.09-2.18c0-0.45,0.73-0.7,2.18-0.75c0.82-0.02,1.26-0.25,1.33-0.68c0.14-0.86,0.18-2.22,0.14-4.08 c-0.09-2.92-0.14-4.32-0.14-4.18c0-2.63,0.25-3.94,0.75-3.94c0.61,0,1.49,0.14,2.62,0.41c1.29,0.29,2.19,0.46,2.69,0.51 c1.16,0.16,2.9,0.37,5.24,0.65c0.57,0.04,0.85,0.24,0.85,0.58c0,0.91-0.07,2.28-0.22,4.11c-0.15,1.84-0.22,3.22-0.22,4.15 c0,1.11,0.33,1.67,0.99,1.67c0.79,0,1.99-0.03,3.6-0.1c1.61-0.07,2.82-0.1,3.64-0.1c0.5,0,0.75,0.17,0.75,0.51 c0,0.52-0.06,1.3-0.17,2.35c-0.11,1.04-0.17,1.83-0.17,2.35c0,0.54,0.01,1.34,0.03,2.38c0.02,1.04,0.03,1.84,0.03,2.38 c0,0.48-0.33,0.71-0.99,0.71c-0.45,0-1.21-0.02-2.28-0.05c-1.07-0.03-1.83-0.05-2.28-0.05h-2.55c-0.34,0-0.51,0.5-0.51,1.5 c0,0.54,0,1.35,0,2.41c0.02,1.09,0.03,1.89,0.03,2.42c0,1.9,0.21,3.22,0.65,3.94c0.61,0.98,1.81,1.46,3.6,1.46 c0.57,0,1.38-0.13,2.43-0.39c1.05-0.26,1.8-0.39,2.23-0.39C346.19,440.78,346.43,441.03,346.43,441.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.71,434.76c0,5.17-1.58,9.36-4.74,12.58c-3.16,3.22-7.32,4.83-12.46,4.83c-4.99,0-9.09-1.59-12.31-4.76 c-3.22-3.17-4.83-7.25-4.83-12.24c0-5.26,1.54-9.53,4.63-12.8s7.25-4.91,12.52-4.91c5.12,0,9.27,1.6,12.45,4.81 C381.13,425.47,382.71,429.63,382.71,434.76z M371.56,434.76c0-1.79-0.56-3.37-1.67-4.74c-1.11-1.37-2.55-2.06-4.32-2.06 c-1.79,0-3.26,0.7-4.42,2.11c-1.09,1.32-1.63,2.88-1.63,4.69c0,1.84,0.54,3.41,1.63,4.73c1.16,1.41,2.63,2.11,4.42,2.11 c1.77,0,3.23-0.7,4.39-2.11C371.03,438.17,371.56,436.59,371.56,434.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.38,430.3c0,0.88-0.49,1.33-1.46,1.33c-0.43,0-1.06-0.03-1.89-0.08c-0.83-0.06-1.45-0.08-1.85-0.08 c-1.88,0-3.16,0.29-3.84,0.88c-0.68,0.59-1.02,1.78-1.02,3.57c0,0.97,0.02,2.45,0.05,4.44c0.03,1.98,0.05,3.46,0.05,4.44 c0,0.66,0.04,1.64,0.14,2.94s0.14,2.27,0.14,2.91c0,0.54-0.37,0.85-1.12,0.92c-1.09,0.09-2.75,0.14-5,0.14 c-2.15,0-3.88-0.07-5.17-0.2c-0.75-0.09-1.12-0.46-1.12-1.12c0-1.81,0.01-4.53,0.03-8.14c0.02-3.62,0.03-6.33,0.03-8.15 c0-5.33-0.49-9.71-1.46-13.16c-0.05-0.2-0.07-0.38-0.07-0.51c0-0.34,0.17-0.57,0.51-0.68c1.25-0.14,3.07-0.39,5.47-0.75 c3.58-0.7,5.43-1.05,5.54-1.05c0.41,0,0.67,0.71,0.78,2.14s0.32,2.14,0.61,2.14c-0.32,0,0.61-0.6,2.79-1.79 c2.18-1.19,4.27-1.79,6.29-1.79c1.27,0,1.9,0.27,1.9,0.82c0,0.66-0.07,1.59-0.2,2.79c-0.14,1.29-0.22,2.22-0.24,2.79 c0,0.66,0.01,1.53,0.03,2.62C409.35,428.99,409.38,429.87,409.38,430.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.25,423.98c0,0.23-0.17,0.53-0.51,0.92c-0.64-0.16-1.27-0.24-1.91-0.24c-1.34,0-2.46,0.29-3.37,0.88 c-1.09,0.68-1.63,1.64-1.63,2.89c0,0.79,0.58,1.8,1.73,3.03c1.75,1.84,2.82,3.07,3.23,3.71c1.16,1.72,1.73,3.57,1.73,5.54 c0,1.16-0.23,2.38-0.68,3.67c-0.52,1.43-1.18,2.47-1.97,3.13c-1.68,1.45-3.64,2.67-5.88,3.67c-2.43,1.04-4.66,1.56-6.7,1.56 c-0.45,0-1.47-1.23-3.04-3.69c-1.58-2.46-2.36-3.96-2.36-4.51c0-0.2,0.12-0.33,0.37-0.37c1.59-0.29,3.18-0.59,4.79-0.88 c1.99-0.63,2.99-1.68,2.99-3.13c0-1-0.58-2.15-1.73-3.47c-2.06-2.29-3.14-3.5-3.23-3.64c-1.16-1.63-1.73-3.36-1.73-5.17 c0-3.4,1.72-6.29,5.17-8.67c3.08-2.11,6.38-3.16,9.9-3.16c0.36,0,1.26,1.22,2.69,3.66C432.54,422.15,433.25,423.57,433.25,423.98 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.6592,
    y1: 428.0918,
    x2: 433.249,
    y2: 428.0918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F5668"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#373D4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181D28"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M126.3,450.43c0,0.48-0.1,0.77-0.31,0.88c-0.09,0.07-0.41,0.13-0.95,0.17c-1.38,0.14-3.33,0.2-5.85,0.2 c-3.56,0-5.65-0.07-6.27-0.2c-0.62-0.14-0.94-0.44-0.94-0.92c0-1.79,0.08-4.48,0.25-8.08c0.17-3.59,0.25-6.29,0.25-8.08 c0-0.88-0.25-1.39-0.75-1.53c-0.77-0.18-3.51-0.27-8.23-0.27c-4.74,0-7.5,0.09-8.3,0.27c-0.5,0.11-0.75,0.62-0.75,1.53 c0,1.77,0.06,4.42,0.17,7.94c0.11,3.53,0.17,6.17,0.17,7.94c0,0.68-0.31,1.08-0.92,1.19c-0.73,0.14-2.86,0.2-6.39,0.2 c-3.06,0-5.01-0.07-5.85-0.2c-0.66-0.11-0.99-0.46-0.99-1.05c0-2.45,0.12-6.14,0.36-11.09c0.24-4.94,0.36-8.65,0.36-11.12 c0-2.63-0.11-6.58-0.34-11.85c-0.23-5.27-0.34-9.22-0.34-11.85c0-0.5,0.24-0.75,0.71-0.75c0.7,0,1.76,0.03,3.18,0.1 c1.42,0.07,2.48,0.1,3.18,0.1c0.73,0,1.82-0.03,3.28-0.1s2.56-0.1,3.28-0.1c0.39,0,0.58,0.2,0.58,0.61c0,1.7-0.13,4.25-0.37,7.63 c-0.25,3.39-0.37,5.93-0.37,7.63c0,0.79,0.21,1.26,0.65,1.39c0.59,0.18,3.49,0.27,8.71,0.27c4.85,0,7.66-0.09,8.43-0.27 c0.54-0.14,0.82-0.6,0.82-1.39c0-1.63-0.08-4.1-0.24-7.4c-0.16-3.3-0.24-5.78-0.24-7.43c0-0.7,0.28-1.05,0.85-1.05 c0.66,0,1.66,0.03,3.01,0.1c1.35,0.07,2.36,0.1,3.04,0.1c0.66,0,1.66-0.03,3.01-0.1c1.35-0.07,2.36-0.1,3.04-0.1 c0.66,0,0.99,0.27,0.99,0.82c0,2.61-0.11,6.54-0.32,11.8s-0.32,9.21-0.32,11.83c0,2.47,0.12,6.18,0.36,11.12 S126.3,447.99,126.3,450.43z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.6592,
    y1: 428.0918,
    x2: 433.249,
    y2: 428.0918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F5668"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#373D4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181D28"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M167.31,420.58c0,1.68-0.08,4.2-0.24,7.55c-0.16,3.36-0.24,5.87-0.24,7.55c0,1.63,0.06,4.08,0.17,7.35 c0.11,3.26,0.17,5.7,0.17,7.31c0,0.61-0.28,1-0.85,1.16c-0.86,0.23-2.69,0.34-5.48,0.34c-2.47,0-4.19-0.07-5.17-0.2 c-0.43-0.07-0.7-0.34-0.82-0.82c-0.07-0.68-0.14-1.36-0.2-2.04c-0.11-1.04-0.27-1.56-0.48-1.56c0.32,0-0.83,0.77-3.43,2.31 c-2.61,1.54-4.98,2.31-7.11,2.31c-6.01,0-9.57-2.71-10.68-8.13c-0.5-2.52-0.75-6.17-0.75-10.95c0-5.17,0.42-9.25,1.26-12.24 c0.25-0.93,0.71-1.39,1.39-1.39c1.04,0,2.63,0.01,4.76,0.03c2.13,0.02,3.72,0.03,4.76,0.03c0.7,0,1.05,0.29,1.05,0.88 c0,0.16-0.02,0.4-0.07,0.71c-0.48,3.08-0.71,6.21-0.71,9.39c0,3.94,0.12,6.64,0.37,8.09c0.41,2.49,1.89,3.74,4.46,3.74 c1,0,2.08-0.44,3.25-1.33c1.17-0.88,1.77-1.8,1.82-2.75c0.05-0.84,0.07-6.53,0.07-17.07c0-0.75,0.06-1.19,0.17-1.33 c0.14-0.23,0.54-0.34,1.22-0.34c1.11,0,2.78,0.01,5.02,0.03c2.23,0.02,3.91,0.03,5.02,0.03c0.68,0,1.08,0.17,1.19,0.51 C167.29,419.94,167.31,420.21,167.31,420.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.6592,
    y1: 428.0918,
    x2: 433.249,
    y2: 428.0918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F5668"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#373D4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181D28"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M206.72,450.5c0,0.61-0.32,0.96-0.95,1.05c-0.63,0.09-2.29,0.14-4.96,0.14c-2.86,0-4.63-0.07-5.31-0.2 s-1.02-0.6-1.02-1.39c0-1.07,0.03-2.67,0.1-4.83c0.07-2.15,0.1-3.77,0.1-4.86c0-0.84-0.02-2.09-0.07-3.76 c-0.05-1.67-0.07-2.92-0.07-3.76c0-3.11-1.35-4.66-4.05-4.66c-0.88,0-1.92,0.39-3.09,1.16c-1.27,0.86-1.9,1.71-1.9,2.55v18.36 c0,0.75-0.35,1.17-1.05,1.26c-0.79,0.09-2.41,0.14-4.86,0.14c-2.65,0-4.38-0.07-5.17-0.2c-0.7-0.11-1.05-0.49-1.05-1.12 c0-1.77,0.01-4.43,0.03-7.99c0.02-3.56,0.03-6.23,0.03-8.03c0-5.65-0.44-10.08-1.33-13.3c-0.05-0.2-0.07-0.37-0.07-0.51 c0-0.36,0.17-0.61,0.51-0.75c1.43-0.16,3.33-0.41,5.71-0.75c3.6-0.7,5.63-1.05,6.09-1.05c0.25,0,0.44,0.76,0.58,2.29 c0.14,1.53,0.33,2.3,0.58,2.3c-0.25,0,0.97-0.79,3.66-2.36c2.69-1.58,5.04-2.36,7.06-2.36c2.88,0,5.28,0.68,7.21,2.04 c2.15,1.56,3.23,3.74,3.23,6.53v10.85c0,1.47,0.01,3.68,0.03,6.61C206.71,446.83,206.72,449.03,206.72,450.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.6592,
    y1: 428.0918,
    x2: 433.249,
    y2: 428.0918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F5668"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#373D4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181D28"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M280.76,450.43c0,0.7-0.33,1.05-0.99,1.05h-12.04c-0.66,0-0.99-0.4-0.99-1.19c0-2.29,0.09-5.72,0.26-10.3 c0.17-4.58,0.25-8.01,0.25-10.3c0-0.66-0.1-1.01-0.31-1.05c-0.25,0.14-1.77,3.64-4.56,10.51c-1.63,4.04-3.26,8.06-4.9,12.07 c-0.23,0.52-0.51,0.83-0.85,0.92c-0.12,0.02-0.57,0.03-1.36,0.03c-1.18,0-1.88-0.23-2.11-0.68c-1.22-2.49-2.83-6.12-4.83-10.88 c-2.13-5.03-3.73-8.67-4.79-10.92c-0.05-0.11-0.15-0.24-0.31-0.37c-0.16,0.2-0.24,0.53-0.24,0.99c0,2.22,0.06,5.55,0.17,10 s0.17,7.78,0.17,10c0,0.79-0.32,1.19-0.95,1.19h-11.36c-0.45,0-0.73-0.07-0.83-0.22s-0.15-0.4-0.15-0.77 c0-2.47,0.12-6.18,0.36-11.14c0.24-4.95,0.36-8.67,0.36-11.14c0-2.63-0.11-7.56-0.34-14.79c-0.02-1.88-0.13-4.68-0.31-8.4 l-0.03-0.58c-0.02-0.45,0.45-0.68,1.43-0.68c1.25,0,3.12-0.04,5.61-0.12c2.49-0.08,4.36-0.12,5.61-0.12 c0.25,0,0.6,0.48,1.05,1.43l9.93,21.8c0.7,1.47,1.29,2.21,1.77,2.21c0.25,0,0.78-0.85,1.6-2.55c2.29-4.76,5.68-11.94,10.17-21.53 c0.38-0.88,0.8-1.33,1.26-1.33c0.66,0,1.65,0.03,2.98,0.1s2.33,0.1,3.01,0.1c0.57,0,1.43-0.06,2.6-0.17 c1.17-0.11,2.04-0.17,2.6-0.17c0.68,0,1.02,0.27,1.02,0.82c0,2.68-0.1,6.67-0.29,11.99c-0.19,5.32-0.29,9.31-0.29,11.99 c0,2.47,0.1,6.18,0.31,11.12S280.76,447.99,280.76,450.43z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.6592,
    y1: 428.0918,
    x2: 433.249,
    y2: 428.0918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F5668"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#373D4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181D28"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M319.56,434.76c0,5.17-1.58,9.36-4.74,12.58c-3.16,3.22-7.32,4.83-12.46,4.83c-4.99,0-9.09-1.59-12.31-4.76 c-3.22-3.17-4.83-7.25-4.83-12.24c0-5.26,1.54-9.53,4.63-12.8s7.25-4.91,12.52-4.91c5.12,0,9.27,1.6,12.45,4.81 C317.97,425.47,319.56,429.63,319.56,434.76z M308.41,434.76c0-1.79-0.56-3.37-1.67-4.74c-1.11-1.37-2.55-2.06-4.32-2.06 c-1.79,0-3.26,0.7-4.42,2.11c-1.09,1.32-1.63,2.88-1.63,4.69c0,1.84,0.54,3.41,1.63,4.73c1.16,1.41,2.63,2.11,4.42,2.11 c1.77,0,3.23-0.7,4.39-2.11C307.87,438.17,308.41,436.59,308.41,434.76z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.6592,
    y1: 428.0918,
    x2: 433.249,
    y2: 428.0918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F5668"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#373D4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181D28"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M346.43,441.53c0,0.68-0.08,1.71-0.25,3.09s-0.25,2.4-0.25,3.04c0,0.65-0.07,1.06-0.2,1.24 c-0.14,0.18-0.51,0.44-1.12,0.78c-2.92,1.61-6.17,2.42-9.73,2.42c-6.55,0-9.83-2.5-9.83-7.52c0-1.5,0.06-3.75,0.17-6.75 c0.11-3,0.17-5.25,0.17-6.75c0-1-0.58-1.5-1.73-1.5c-0.09,0-0.24,0-0.44,0c-0.2,0.02-0.35,0.03-0.44,0.03 c-0.86,0-1.29-0.31-1.29-0.92c0-0.36,0.03-0.92,0.09-1.67c0.06-0.75,0.08-1.3,0.08-1.67c0-0.48-0.03-1.2-0.08-2.18 c-0.06-0.97-0.09-1.7-0.09-2.18c0-0.45,0.73-0.7,2.18-0.75c0.82-0.02,1.26-0.25,1.33-0.68c0.14-0.86,0.18-2.22,0.14-4.08 c-0.09-2.92-0.14-4.32-0.14-4.18c0-2.63,0.25-3.94,0.75-3.94c0.61,0,1.49,0.14,2.62,0.41c1.29,0.29,2.19,0.46,2.69,0.51 c1.16,0.16,2.9,0.37,5.24,0.65c0.57,0.04,0.85,0.24,0.85,0.58c0,0.91-0.07,2.28-0.22,4.11c-0.15,1.84-0.22,3.22-0.22,4.15 c0,1.11,0.33,1.67,0.99,1.67c0.79,0,1.99-0.03,3.6-0.1c1.61-0.07,2.82-0.1,3.64-0.1c0.5,0,0.75,0.17,0.75,0.51 c0,0.52-0.06,1.3-0.17,2.35c-0.11,1.04-0.17,1.83-0.17,2.35c0,0.54,0.01,1.34,0.03,2.38c0.02,1.04,0.03,1.84,0.03,2.38 c0,0.48-0.33,0.71-0.99,0.71c-0.45,0-1.21-0.02-2.28-0.05c-1.07-0.03-1.83-0.05-2.28-0.05h-2.55c-0.34,0-0.51,0.5-0.51,1.5 c0,0.54,0,1.35,0,2.41c0.02,1.09,0.03,1.89,0.03,2.42c0,1.9,0.21,3.22,0.65,3.94c0.61,0.98,1.81,1.46,3.6,1.46 c0.57,0,1.38-0.13,2.43-0.39c1.05-0.26,1.8-0.39,2.23-0.39C346.19,440.78,346.43,441.03,346.43,441.53z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.6592,
    y1: 428.0918,
    x2: 433.249,
    y2: 428.0918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F5668"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#373D4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181D28"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M382.71,434.76c0,5.17-1.58,9.36-4.74,12.58c-3.16,3.22-7.32,4.83-12.46,4.83c-4.99,0-9.09-1.59-12.31-4.76 c-3.22-3.17-4.83-7.25-4.83-12.24c0-5.26,1.54-9.53,4.63-12.8s7.25-4.91,12.52-4.91c5.12,0,9.27,1.6,12.45,4.81 C381.13,425.47,382.71,429.63,382.71,434.76z M371.56,434.76c0-1.79-0.56-3.37-1.67-4.74c-1.11-1.37-2.55-2.06-4.32-2.06 c-1.79,0-3.26,0.7-4.42,2.11c-1.09,1.32-1.63,2.88-1.63,4.69c0,1.84,0.54,3.41,1.63,4.73c1.16,1.41,2.63,2.11,4.42,2.11 c1.77,0,3.23-0.7,4.39-2.11C371.03,438.17,371.56,436.59,371.56,434.76z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.6592,
    y1: 428.0918,
    x2: 433.249,
    y2: 428.0918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F5668"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#373D4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181D28"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M409.38,430.3c0,0.88-0.49,1.33-1.46,1.33c-0.43,0-1.06-0.03-1.89-0.08c-0.83-0.06-1.45-0.08-1.85-0.08 c-1.88,0-3.16,0.29-3.84,0.88c-0.68,0.59-1.02,1.78-1.02,3.57c0,0.97,0.02,2.45,0.05,4.44c0.03,1.98,0.05,3.46,0.05,4.44 c0,0.66,0.04,1.64,0.14,2.94s0.14,2.27,0.14,2.91c0,0.54-0.37,0.85-1.12,0.92c-1.09,0.09-2.75,0.14-5,0.14 c-2.15,0-3.88-0.07-5.17-0.2c-0.75-0.09-1.12-0.46-1.12-1.12c0-1.81,0.01-4.53,0.03-8.14c0.02-3.62,0.03-6.33,0.03-8.15 c0-5.33-0.49-9.71-1.46-13.16c-0.05-0.2-0.07-0.38-0.07-0.51c0-0.34,0.17-0.57,0.51-0.68c1.25-0.14,3.07-0.39,5.47-0.75 c3.58-0.7,5.43-1.05,5.54-1.05c0.41,0,0.67,0.71,0.78,2.14s0.32,2.14,0.61,2.14c-0.32,0,0.61-0.6,2.79-1.79 c2.18-1.19,4.27-1.79,6.29-1.79c1.27,0,1.9,0.27,1.9,0.82c0,0.66-0.07,1.59-0.2,2.79c-0.14,1.29-0.22,2.22-0.24,2.79 c0,0.66,0.01,1.53,0.03,2.62C409.35,428.99,409.38,429.87,409.38,430.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.6592,
    y1: 428.0918,
    x2: 433.249,
    y2: 428.0918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F5668"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#373D4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181D28"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M433.25,423.98c0,0.23-0.17,0.53-0.51,0.92c-0.64-0.16-1.27-0.24-1.91-0.24c-1.34,0-2.46,0.29-3.37,0.88 c-1.09,0.68-1.63,1.64-1.63,2.89c0,0.79,0.58,1.8,1.73,3.03c1.75,1.84,2.82,3.07,3.23,3.71c1.16,1.72,1.73,3.57,1.73,5.54 c0,1.16-0.23,2.38-0.68,3.67c-0.52,1.43-1.18,2.47-1.97,3.13c-1.68,1.45-3.64,2.67-5.88,3.67c-2.43,1.04-4.66,1.56-6.7,1.56 c-0.45,0-1.47-1.23-3.04-3.69c-1.58-2.46-2.36-3.96-2.36-4.51c0-0.2,0.12-0.33,0.37-0.37c1.59-0.29,3.18-0.59,4.79-0.88 c1.99-0.63,2.99-1.68,2.99-3.13c0-1-0.58-2.15-1.73-3.47c-2.06-2.29-3.14-3.5-3.23-3.64c-1.16-1.63-1.73-3.36-1.73-5.17 c0-3.4,1.72-6.29,5.17-8.67c3.08-2.11,6.38-3.16,9.9-3.16c0.36,0,1.26,1.22,2.69,3.66C432.54,422.15,433.25,423.57,433.25,423.98 z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "TEXTS"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHunmotors);
export default __webpack_public_path__ + "static/media/hun motors.4f93e3d906244a967cb243de358a779b.svg";
export { ForwardRef as ReactComponent };